import dayjs from 'dayjs';

export function formatDurationMs(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) return '-';
  const totalSec = Math.floor(ms / 1000);
  const hours = Math.floor(totalSec / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;
  if (hours > 0) return `${hours}시간 ${minutes}분 ${seconds}초`;
  if (minutes > 0) return `${minutes}분 ${seconds}초`;
  return `${seconds}초`;
}

/** triggeredAt ~ completedAt(또는 now) 구간의 소요 시간 */
export function formatGroupingRunDuration(
  triggeredAt?: string | null,
  completedAt?: string | null,
  now: Date = new Date(),
): string {
  if (!triggeredAt) return '-';
  const start = dayjs(triggeredAt);
  if (!start.isValid()) return '-';
  const end = completedAt ? dayjs(completedAt) : dayjs(now);
  if (!end.isValid()) return '-';
  return formatDurationMs(end.diff(start));
}
